export default __webpack_public_path__ + "images/01dcb16b878a21c5c281fef5c705561e.png";